// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__14gF7","requiredAsterisk":"Info_requiredAsterisk__1rxAq"};